import { ReactElement } from 'react';
import { ISearchListResultProps } from './SearchListResult/SearchListResult';
import css from './SearchListResults.module.scss';

export interface ISearchListResults {
    children?:
    | ReactElement<ISearchListResultProps>
    | Array<ReactElement<ISearchListResultProps>>
    | Array<ReactElement<ISearchListResultProps> | Array<ReactElement<ISearchListResultProps>> | undefined>;
}

export const SearchListResults = (props: ISearchListResults) => <div className={css.searchListResult}>{props.children}</div>;
